import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserSaveSendDialogComponent } from './user-save-send-dialog.component';
import { DialogCloseModule } from '../dialog-close/dialog-close.module';
import { TranslateModule } from '@xref/ngx';
import { MatButtonModule } from '@angular/material/button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [UserSaveSendDialogComponent],
  exports: [UserSaveSendDialogComponent],
  imports: [
    CommonModule,
    TranslateModule,
    DialogCloseModule,
    MatButtonModule,
    FontAwesomeModule
  ]
})
export class UserSaveSendDialogModule {}
